import { render, staticRenderFns } from "./elem-form.vue?vue&type=template&id=74d9eab6&scoped=true&"
import script from "./elem-form.vue?vue&type=script&lang=js&"
export * from "./elem-form.vue?vue&type=script&lang=js&"
import style0 from "./elem-form.vue?vue&type=style&index=0&id=74d9eab6&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d9eab6",
  null
  
)

export default component.exports